import React from 'react';

export const LiveEventContext = React.createContext(false);
